import { useState, useEffect } from 'react';
import NavBar from "./NavBar";
import { Routes, Route } from 'react-router-dom';
import Login from './Login';
import Alumnos from './Alumnos';
import Resultados from "./Resultados";
import Liquidacion from "./Liquidacion";
import VerLiquid from "./VerLiquid";
import Secciones from "./Secciones";
import VarAlumnos from "./VarAlumnos";
import VarSecciones from "./VarSecciones";
import Favoritos from "./Favoritos";
import RepoAlumnos from './RepoAlumnos';
import Logoff from './Logoff';
import Sidebar from './Sidebar';
import Conceptos from './Concepto';

const App = () => {

  const [token, setToken] = useState("");
  const [usrId, setUsrId] = useState(0);
  const [usrName, setUsrName] = useState("");
  const [usrGrupo, setUsrGrupo] = useState(0);
  const [grupo, setGrupo] = useState(0);
  const [modalShow, setModalShow] = useState(true);


  const newToken = (tokenData) => setToken(tokenData);
  const newUsrId = (usrId) => setUsrId(usrId);
  const newUsrName = (usrNameData) => setUsrName(usrNameData);

  const newUsrGrupo = (usrGrupoData) => setUsrGrupo(usrGrupoData);
  const newGrupo = (grupoData) => setGrupo(grupoData);


  // verificar si estoy en desarrollo y evitar el login

  var log_usr = '';

  useEffect(() => {
    if (log_usr === 'N') {
      setToken('pppp');
      setUsrId(1);
      setUsrName('Lucho DEV');
      setUsrGrupo(2);
      setGrupo(1);
      console.log("App:", grupo, usrGrupo);
    }
  }, [log_usr]);



  log_usr = `${process.env.REACT_APP_LOG_USR}`;
  console.log("logusr", log_usr, "--");



  if (token === "") {
/*
    if (log_usr == 'N')
    {
        setToken('pppp');
        setUsrId(1);
        setUsrName('Lucho DEV');
        setUsrGrupo(2);
        setGrupo(1);
        

    }
  */  return (
      <>
        <NavBar usrName={usrName} />
        <Login
          show={modalShow}
          onHide={() => setModalShow(false)}

          newToken={newToken}
          newUsrId={newUsrId}
          newUsrName={newUsrName}
          newUsrGrupo={newUsrGrupo}
          newGrupo={newGrupo}

        />
      </>
    );

  }

  /*(
   <>
     <NavBar usrName={usrName} vprofile={""} vgrusu={usrGrupo} />
     <Routes>
       <Route path="/alumnos" element={<Alumnos vtoken={token} grupo={grupo} grusu={usrGrupo} />} />
       <Route path="/liquidar" element={<Liquidacion vtoken={token} grupo={grupo} grusu={usrGrupo} />} />
       <Route path="/resultados" element={<Resultados searchtext={''} vtoken={token} />} />
       <Route path="/favoritos" element={<Favoritos />} />
       <Route path="/verliquid" element={<VerLiquid grupo={grupo} grusu={usrGrupo} />} />
       <Route path="/secciones" element={<Secciones grupo={grupo} grusu={usrGrupo} />} />
       <Route path="/varalumnos" element={<VarAlumnos grupo={grupo} grusu={usrGrupo} />} />
       <Route path="/varsecciones" element={<VarSecciones grupo={grupo} grusu={usrGrupo} />} />
       <Route path="/repoAlumnos" element={<RepoAlumnos grusu={usrGrupo} />} />
       <Route path="/salir" element={<Logoff

         newToken={newToken}
         newUsrId={newUsrId}
         newUsrName={newUsrName}
         newUsrGrupo={newUsrGrupo}
         newGrupo={newGrupo}
         onShow={() => setModalShow(true)}
       />} />
     </Routes>
   </>
 );*/
  return (

    <div className="layout">

      <Sidebar />

      <div className="main">

        <NavBar
          usrName={usrName}
          vprofile={""}
          vgrusu={usrGrupo}
        />

        <div className="contenido">

          <Routes>

            <Route
              path="/alumnos"
              element={
                <Alumnos
                  vtoken={token}
                  grupo={grupo}
                  grusu={usrGrupo}
                />
              }
            />

            <Route
              path="/liquidar"
              element={
                <Liquidacion
                  vtoken={token}
                  grupo={grupo}
                  grusu={usrGrupo}
                />
              }
            />
            <Route
              path="/conceptos"
              element={
                <Conceptos
                  grupo={grupo}
                  grusu={usrGrupo}
                />
              }
            />
            <Route
              path="/resultados"
              element={
                <Resultados
                  searchtext={''}
                  vtoken={token}
                />
              }
            />

            <Route
              path="/favoritos"
              element={<Favoritos />}
            />

            <Route
              path="/verliquidaciones"
              element={
                <VerLiquid
                  grupo={grupo}
                  grusu={usrGrupo}
                />
              }
            />

            <Route
              path="/secciones"
              element={
                <Secciones
                  grupo={grupo}
                  grusu={usrGrupo}
                />
              }
            />

            <Route
              path="/varalumnos"
              element={
                <VarAlumnos
                  grupo={grupo}
                  grusu={usrGrupo}
                />
              }
            />

            <Route
              path="/varsecciones"
              element={
                <VarSecciones
                  grupo={grupo}
                  grusu={usrGrupo}
                />
              }
            />

            <Route
              path="/repoAlumnos"
              element={
                <RepoAlumnos
                  grusu={usrGrupo}
                />
              }
            />

            <Route
              path="/salir"
              element={
                <Logoff
                  newToken={newToken}
                  newUsrId={newUsrId}
                  newUsrName={newUsrName}
                  newUsrGrupo={newUsrGrupo}
                  newGrupo={newGrupo}
                  onShow={() => setModalShow(true)}
                />
              }
            />

          </Routes>

        </div>

      </div>

    </div>
  );




};

export default App;